import Actions from '@/dictionary/tracking/actions';
import { SocialIncentiveButtonsBase } from '../SocialIncentiveButtons/SocialIncentiveButtonsBase.class';

export default class PrivacyStatement extends SocialIncentiveButtonsBase {
	public trackTermsAndConditionsClick(): void {
		this.trackButtonClick(Actions.TERMS_AND_CONDITIONS_CLICK);
	}
	public trackPrivacyStatementClick(): void {
		this.trackButtonClick(Actions.PRIVACY_STATEMENT_CLICK);
	}
}
